import React from 'react';
import {useTranslation} from 'react-i18next';
import AccountControlPanel from '../AccountControlPanel/AccountControlPanel';
import Header from '../../components/ListViewHeader/Header';
import AccountDashboardCallActivityWidget from './Widgets/AccountDashboardCallActivityWidget';
import {useStyles} from './AccountDashboard.utils';
import AccountDashboardRingGroupsWidget from './Widgets/AccountDashboardRingGroupsWidget';
import AccountDashboardCallForwardingWidget from './Widgets/AccountDashboardCallForwardingWidget';
import AccountDashboardPlanWidget from './Widgets/AccountDashboardPlanWidget';
import usePageTitle from '../../hooks/usePageTitle';

const AccountDashboard = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    usePageTitle();

    return (
        <div className={classes.mainDashboardContainer}>
            <div className={classes.header}>
                <Header title={t('screens:dashboard.dashboard')} hideTotal/>
                <div className={classes.rightSection}>
                    <AccountControlPanel />
                </div>
            </div>
            <div className={classes.dashboardContentContainer}>
                
                <div className={classes.dashboardLeftPart}>
                    <AccountDashboardCallActivityWidget />
                </div>
                
                <div className={classes.dashboardRightPart}>
                    <AccountDashboardRingGroupsWidget />

                    <AccountDashboardCallForwardingWidget />

                    <AccountDashboardPlanWidget />
                </div>
            </div>
            
        </div>
    );
};

export default AccountDashboard;
